/**
 * Created by 赵禹 on 2018/2/3.
 */
import { addGoodsCartV2, deleteGoodsCartV2, getCartListV2, cleanCartV2 } from 'api/goodsCart';
const cart = {
  state: {
    added: [] // 购物车商品
  },
  getters: {
    // 获取当前购物车
    cartProducts: (state, getters, rootState) => {
      return state.added
    },
    // 购物车商品总价
    cartTotalPrice: (state, getters) => {
      return getters.cartProducts.reduce((total, product) => {
        return total + product.coupPrice * product.num
      }, 0)
    },
    // 购物车数量
    cartNums: (state, getters) => {
      let num = 0;
      //1.统计商品所有的数量
      // state.added.forEach(i =>{
      //     num += Number(i.num);
      // });
      //2.统计商品的类别数
      num = state.added.length;

      if (num == 0 && this.oldNum) {
        return this.oldNum;
      }
      this.oldNum = num;
      return num;
    }
  },
  mutations: {
    // 添加购物车
    'ADD_TO_CART': (state, item) => {
      state.added = state.added.concat(item)
    },
    // 清空购物车
    'CLEAN_CART': (state) => {
      state.added = [];
      this.oldNum = 0;
    },
    // 从购物车删除
    'DELETE_TO_CART': (state, id) => {
      state.added.map((item, index) => {
        if (item.goodsId == id) {
          state.added.splice(index, 1)
        }
      });
      if (state.added.length == 0) this.oldNum = 0;
    }
  },
  actions: {
    // 添加购物车请求
    addCart({ dispatch, commit }, product) {
      return new Promise((resolve, reject) => {
        addGoodsCartV2({
          goodsId: product.id,
          goodsNum: product.num,
          promotePurchaseType: ''
        }).then(res => {
          if (res.resCode === 1) {
            dispatch('getCartList')
          } else {
            console.log('添加购物车失败')
          }
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 获取购物车请求
    getCartList({ commit }) {
      commit('CLEAN_CART')
      return new Promise((resolve, reject) => {
        getCartListV2().then(res => {
          if (res.resCode === 1 && res.data) {
            res.data.map((item, index) => {
              item.isCheck = false // 是否选中去下单
              commit('ADD_TO_CART', item)
            })
          }
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 从购物车删除请求
    deleteCart({ commit }, id) {
      if (confirm('您确实要把该商品移出购物车吗？')) {
        return new Promise((resolve, reject) => {
          let data = {
            goodsIds: id
          }
          deleteGoodsCartV2(data).then(res => {
            if (res.resCode == 1) {
              commit('DELETE_TO_CART', id)
            } else {
              console.log('从购物车删除失败')
            }
            resolve(res);
          }).catch(error => {
            reject(error);
          });
        });
      }
    },
    // 登录情况清空购物车
    cleanCart({ commit }) {
      if (confirm('您确认要清空购物车吗？')) {
        return new Promise((resolve, reject) => {
          cleanCartV2().then(res => {
            if (res.resCode == 1) {
              commit('CLEAN_CART')
            } else {
              console.log('从购物车删除失败')
            }
            resolve(res);
          }).catch(error => {
            reject(error);
          });
        });
      }
    },
    // 退出登录时清空购物车
    cleanCartLogOut({ commit }) {
      //console.log('CLEAN_CART')
      commit('CLEAN_CART')
    }
  }
}
export default cart;



// WEBPACK FOOTER //
// ./src/components/store/modules/goodsCart.js